import { AxiosResponse } from 'axios'
import { api } from 'API'
import { IDecisionPoint, IDecisionPointMedia, IDecisionPointStep } from 'interfaces/decisionPoint'

export async function createDecisionPoint(decisionPoint: IDecisionPoint): Promise<IDecisionPoint> {
  const response: AxiosResponse = await api.post(`/decision-points`, decisionPoint)
  return response.data
}

export async function createDecisionPoints(decisionPoints: IDecisionPoint[]): Promise<IDecisionPoint[]> {
  const response: AxiosResponse = await api.post(`/decision-points/create-many`, decisionPoints)
  return response.data
}

export async function createDecisionPointMedia(decisionPointMedia: IDecisionPointMedia): Promise<IDecisionPointMedia> {
  const response: AxiosResponse = await api.post(`/decision-point-medias`, decisionPointMedia)
  return response.data
}

export async function createDecisionPointMedias(
  decisionPointMedias: IDecisionPointMedia[]
): Promise<IDecisionPointMedia[]> {
  const response: AxiosResponse = await api.post(`/decision-point-medias/create-many`, decisionPointMedias)
  return response.data
}

export async function createDecisionPointStep(decisionPointStep: IDecisionPointStep): Promise<IDecisionPointStep> {
  const response: AxiosResponse = await api.post(`/decision-point-steps`, decisionPointStep)
  return response.data
}

export async function createDecisionPointSteps(
  decisionPointSteps: IDecisionPointStep[]
): Promise<IDecisionPointStep[]> {
  const response: AxiosResponse = await api.post(`/decision-point-steps/create-many`, decisionPointSteps)
  return response.data
}

export async function dropDecisionPoint(textContentsId: number): Promise<void> {
  const response: AxiosResponse = await api.put(`/decision-points/drop`, { textContentsId: textContentsId })
  return response.data
}

export async function dropDecisionPointMedia(decisionPointId: number): Promise<void> {
  const response: AxiosResponse = await api.put(`/decision-point-medias/drop`, {
    decisionPointId: decisionPointId
  })
  return response.data
}

export async function dropDecisionPointStep(decisionPointId: number): Promise<void> {
  const response: AxiosResponse = await api.put(`/decision-point-steps/drop`, {
    decisionPointId: decisionPointId
  })
  return response.data
}
